import * as React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import ArticleIcon from '@mui/icons-material/Article';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import SavingsIcon from '@mui/icons-material/Savings';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepContent } from '@mui/material';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import BoltIcon from '@mui/icons-material/Bolt'; // https://mui.com/material-ui/react-stepper/

// https://mui.com/material-ui/react-stepper/

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
    left: 'calc(-50% + 10px)',
    right: 'calc(50% + 10px)',
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#b4d6fd',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#b4d6fd',
    },
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 42,
  height: 42,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',

  alignItems: 'center',
  ...(ownerState.active && {
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    backgroundColor: '#377bde',
  }),
  ...(ownerState.completed && { backgroundColor: '#b4d6fd' }),
}));

// const ColorlibStepIcon = ({ active, completed, className, icon, color, backgroundColor }) => (
const ColorlibStepIcon = ({ active, completed, className, icon, color, backgroundColor }) => (
  <ColorlibStepIconRoot
    ownerState={{ completed, active }}
    className={`step-icon ${className ? className : ''}`}
    style={{ backgroundColor }}
  >
    {
      {
        settings: <SettingsIcon style={{ color, backgroundColor }} />,
        group: <GroupAddIcon style={{ color, backgroundColor }} />,
        video: <VideoLabelIcon style={{ color, backgroundColor }} />,
        doc: <ArticleIcon style={{ color, backgroundColor }} />,
        identity: <FingerprintIcon style={{ color, backgroundColor }} />,
        bank: <SavingsIcon style={{ color, backgroundColor }} />,
        home: <HomeIcon style={{ color, backgroundColor }} />,
        person: <PersonIcon style={{ color, backgroundColor }} />,
        dollar: <AttachMoneyIcon style={{ color, backgroundColor }} />,
        checkedBox: <CheckBoxOutlinedIcon style={{ color, backgroundColor }} />,
        document: <DescriptionOutlinedIcon style={{ color, backgroundColor }} />,
        bolt: <BoltIcon style={{ color, backgroundColor }} />,
      }[icon]
    }
  </ColorlibStepIconRoot>
);

const ProgressStatusBar = ({
  steps,
  activeIndex,
  variant = 'default',
  orientation = 'horizontal',
  onBeforeStepChange,
  showSteps,
  belowBreadCrumbs,
}) => {
  // if (variant === 'dominos') {
  //   let width = steps.length > 5 ? steps.length * 140 : '768';
  //   return (
  //     <div className={'progress-status-bar'} style={{ width: width + 'px', opacity: '0.75' }}>
  //       <ul>
  //         {steps.map(({ label, icon }, index) => (
  //           <li
  //             className={activeIndex === index ? 'active' : index > activeIndex ? 'next' : 'prev'}
  //             style={{
  //               width: index === steps.length - 1 ? width / steps.length + 50 + 'px' : width / steps.length + 'px',
  //               paddingLeft: index > 0 ? '12px' : '25px',
  //             }}
  //           >
  //             {' '}
  //             <div style={{ width: width / steps.length + 'px', overflow: 'visible' }}>
  //               <EnhancedLabel
  //                 StepIconComponent={(a) =>
  //                   ColorlibStepIcon({
  //                     ...a,
  //                     icon: icon,
  //                     color: activeIndex === index ? 'black' : index > activeIndex ? 'black' : 'black',
  //                     // color: activeIndex === index ? 'white' : 'white',
  //                     backgroundColor: 'transparent', //activeIndex === index ? 'white' : index > activeIndex ? 'gray' : '#235DC0FF',
  //                   })
  //                 }
  //               >
  //                 <div style={{ color: activeIndex === index ? 'black' : index > activeIndex ? 'black' : 'black' }}>
  //                   {label}
  //                 </div>
  //               </EnhancedLabel>
  //             </div>
  //           </li>
  //         ))}
  //       </ul>
  //     </div>
  //   );
  // }

  const stepContent = steps?.[activeIndex]?.content;
  return (
    <Stack className="progress-status-stack" spacing={2}>
      <Stepper
        alternativeLabel
        activeStep={activeIndex ?? -1}
        connector={<ColorlibConnector />}
        className="progress-status-stepper"
        {...{ orientation }}
      >
        {showSteps &&
          steps.map(({ label, icon, content, additionalClassName }, index) => (
            <Step key={label} className={additionalClassName} onClick={() => onBeforeStepChange(activeIndex, index)}>
              <StepLabel StepIconComponent={(a) => ColorlibStepIcon({ ...a, icon })}>
                <span className="step-label-text">{label}</span>
              </StepLabel>
            </Step>
          ))}
      </Stepper>
      {showSteps && belowBreadCrumbs}
      {orientation === 'vertical' && stepContent && <StepContent>{stepContent}</StepContent>}
      {orientation === 'horizontal' && stepContent && <div>{stepContent}</div>}
    </Stack>
  );
};

export default ProgressStatusBar;
